import { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { BrowserRouter as Router, NavLink, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Home";
import Contato from "./Contato";
import Sobre from "./Sobre";
import Verificacao from "./Verificacao";
import Guias from "./Guias";
import GuiaAssemblyARM64 from "./GuiaAssemblyARM64";
import GuiaSubagents from "./GuiaSubagents";
import GuiaMotores from "./GuiaMotores";
import NaoEncontrado from "./NaoEncontrado";
import trocaTema, { initTema, THEME_ORDER, temaValido } from "../functions/trocaTema";
import { Navbar } from "react-bootstrap";

const TEMA_LABELS = {
  cyborg:   "Cyborg (escuro)",
  vapor:    "Vapor (escuro)",
  spacelab: "Spacelab (escuro)",
  journal:  "Journal (claro)",
  minty:    "Minty (escuro)",
  morph:    "Morph (escuro)",
};

const IcoHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-house-fill" viewBox="0 0 16 16">
    <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
    <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
  </svg>
);

const IcoContato = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-envelope-at-fill" viewBox="0 0 16 16">
    <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
    <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
  </svg>
);

const IcoSobre = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-info-square-fill" viewBox="0 0 16 16">
    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </svg>
);

const IcoInfo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
  </svg>
);

const IcoGuias = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-journal-code" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M8.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646a.5.5 0 0 0 0-.708" />
    <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
    <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
  </svg>
);

const IcoTema = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-palette-fill" viewBox="0 0 16 16">
    <path d="M12.433 10.07C14.133 10.585 16 11.15 16 8a8 8 0 1 0-8 8c1.996 0 1.826-1.504 1.649-3.08-.124-1.101-.252-2.237.351-2.92.465-.527 1.42-.237 2.433.07M8 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m4.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
  </svg>
);

const IcoMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
  </svg>
);

function RouteWatcher() {
  const location = useLocation();
  useEffect(() => {
    // Aguarda o componente da rota montar antes de injetar as vars
    const id = setTimeout(initTema, 0);
    return () => clearTimeout(id);
  }, [location.pathname]);
  return null;
}

function Navegacao() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [temaAtivo, setTemaAtivo] = useState(() => temaValido(localStorage.getItem("tema")));

  useEffect(() => { initTema(); }, []);

  function mudarPara(tema) {
    if (tema === temaAtivo) return;
    trocaTema(tema);
    setTemaAtivo(tema);
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <RouteWatcher />
      <div
        className={`sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div
        className={`sidebar transicao bg-body-tertiary border-end${sidebarOpen ? " open" : ""}`}
        data-bs-theme="dark"
      >
        <Nav variant="pills" className="flex-column p-3 gap-2">
          <Nav.Link as={NavLink} to="/" className="d-flex align-items-center gap-2" onClick={() => setSidebarOpen(false)}>
            <IcoHome /> HOME
          </Nav.Link>
          <NavDropdown
            title={<span className="d-flex align-items-center gap-2"><IcoInfo /> INFO</span>}
            id="info-sidebar-dropdown"
          >
            <NavDropdown.Item as={NavLink} to="/Contato" className="d-flex align-items-center gap-2" onClick={() => setSidebarOpen(false)}>
              <IcoContato /> CONTATO
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/Sobre" className="d-flex align-items-center gap-2" onClick={() => setSidebarOpen(false)}>
              <IcoSobre /> SOBRE
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link as={NavLink} to="/Guias" className="d-flex align-items-center gap-2" onClick={() => setSidebarOpen(false)}>
            <IcoGuias /> GUIAS
          </Nav.Link>
          <NavDropdown
            title={<span className="d-flex align-items-center gap-2"><IcoTema /> {temaAtivo.toUpperCase()}</span>}
            id="tema-sidebar-dropdown"
          >
            {THEME_ORDER.map(t => (
              <NavDropdown.Item key={t} active={t === temaAtivo} onClick={() => mudarPara(t)}>
                {TEMA_LABELS[t]}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </Nav>
      </div>
      <Navbar className="bg-body-tertiary border-bottom transicao" sticky="top" data-bs-theme="dark">
        <Nav variant="tabs" className="justify-content-center fixed-left">
          <Nav.Item>
            <Nav.Link onClick={() => setSidebarOpen(true)}><IcoMenu /><br/>MENU</Nav.Link>
          </Nav.Item>
          <Nav.Link as={NavLink} to="/"><IcoHome /><br/>HOME</Nav.Link>
          <NavDropdown title={<><IcoInfo /><br/>INFO</>} id="info-nav-dropdown" align="start">
            <NavDropdown.Item as={NavLink} to="/Contato" className="d-flex align-items-center gap-2">
              <IcoContato /> CONTATO
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/Sobre" className="d-flex align-items-center gap-2">
              <IcoSobre /> SOBRE
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link as={NavLink} to="/Guias"><IcoGuias /><br/>GUIAS</Nav.Link>
          <NavDropdown
            title={<><IcoTema /><br/>{temaAtivo.toUpperCase()}</>}
            id="tema-nav-dropdown"
            align="end"
          >
            {THEME_ORDER.map(t => (
              <NavDropdown.Item key={t} active={t === temaAtivo} onClick={() => mudarPara(t)}>
                {TEMA_LABELS[t]}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </Nav>
      </Navbar>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contato" element={<Contato />} />
        <Route path="/Sobre" element={<Sobre />} />
        <Route path="/verificar" element={<Verificacao />} />
        <Route path="/Guias" element={<Guias />} />
        <Route path="/Guias/assembly-arm64" element={<GuiaAssemblyARM64 />} />
        <Route path="/Guias/subagents-claude" element={<GuiaSubagents />} />
        <Route path="/Guias/motores-robotica" element={<GuiaMotores />} />
        <Route path="*" element={<NaoEncontrado />} />
      </Routes>
    </Router>
  );
}

export default Navegacao;
